import React from 'react';
import { connect } from 'react-redux';
import Select from '@material-ui/core/Select';
import { MenuItem } from '@material-ui/core';
import { Language } from '~/utils/constants';
import { setLanguageAction } from '~/store/actions/uiActions';
import { getBaseContentAction } from '~/store/actions/entitiesActions';
import { getVehicleType, getLanguage } from '~/store/selectors/uiSelectors';
import { isUserInWhiteList } from '~/store/selectors/authSelectors';
import { setLanguageToLocalStorage } from '~/utils/helpers';

function LanguageSelector({ isUserInWhiteList, language: defaultLanguage, vehicleType, dispatch, ...props }) {
  const [language, setLanguage] = React.useState(defaultLanguage);

  const handleChange = (event) => {
    const newLanguage = event.target.value;

    setLanguage(newLanguage);
    setLanguageToLocalStorage(newLanguage);
    dispatch(setLanguageAction(newLanguage)); 
    dispatch(getBaseContentAction(vehicleType, newLanguage));
  };

  return (
    <Select 
      {...props}
      style={{ color: '#009688'}}
      value={language}
      label="Language"
      IconComponent={() => null}
      SelectDisplayProps={{
        style: {
          paddingRight: 0,
        }
      }}
      onChange={handleChange}
    >
      { isUserInWhiteList && <MenuItem value={Language.en}>English</MenuItem> }
      <MenuItem value={Language.sv}>Svenska</MenuItem>
    </Select>
  );
}

const mapStateToProps = (state) => ({
  vehicleType: getVehicleType(state),
  language: getLanguage(state),
  isUserInWhiteList: isUserInWhiteList(state),
});

export default connect(
  mapStateToProps,
)(LanguageSelector);
